import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Dormís mal. Te despertás con calor y cansancio.', 'Tu cuerpo cambió sin avisar. Comés igual y te inflamás / subís fácil.', 'Niebla mental. Te cuesta concentrarte y te olvidás de cosas simples.', 'Energía baja. Todo te agota y a la tarde te caés.'];
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8" data-id="element-182">
      <div className="max-w-3xl mx-auto space-y-14" data-id="element-183">
        {/* Eyebrow title */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center uppercase tracking-[0.3em] text-[#C8A870] font-semibold text-[13px]" data-id="element-184">
          Una historia que podría ser la tuya
        </motion.p>

        {/* Story Block */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="card-premium p-7 md:p-12 relative overflow-hidden" data-id="element-185">
          <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-gradient-to-b from-transparent via-gold/60 to-transparent" data-id="element-186" />

          <div className="space-y-6 pl-3 md:pl-6" data-id="element-187">
            <p className="italic text-[19px] md:text-[22px] text-foreground/80 font-body leading-[1.7]" data-id="element-188">
              María Elena tenía 49 años. Comía bien, caminaba, dormía temprano.
            </p>

            <p className="italic text-[19px] md:text-[22px] text-foreground/80 font-body leading-[1.7]" data-id="element-189">
              Pero algo ya no era igual. Su cintura cambió. Se despertaba
              cansada. Y había días en los que no terminaba de sentirse ella
              misma.
            </p>

            <p className="font-semibold italic text-[20px] md:text-[24px] text-[#F0E8D8] font-body leading-[1.55] pt-1" data-id="element-190">
              "Durante mucho tiempo creyó que necesitaba esforzarse más. Hasta
              que entendió algo: No estaba fallando. Estaba atravesando una
              transición". Y las estrategias de antes ya no alcanzaban.
            </p>

            <div className="divider-fine w-full !mt-8" data-id="element-191" />

            <p className="md:text-[16px] text-foreground/55 font-body pt-2 text-[16px]" data-id="element-192">
              <span className="text-[#C8A870] font-semibold" data-id="element-193">
                Por eso nació H.E.R. Para acompañar esta etapa de forma simple,
                sostenible y pensada para la mujer que sos hoy.
              </span>
            </p>
          </div>
        </motion.div>

        {/* Pain Points */}

        {/* Closing */}
      </div>
    </section>;
}